
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import AppModal from "@/components/common/AppModal.vue";
import { useMeta } from "vue-meta";

export default defineComponent({
  name: "App",
  components: {
    AppModal,
  },
  computed: {
    ...mapGetters(["getShowModal", "getModalTitle", "getModalContent"]),
  },
  setup() {
    useMeta({
      title: "Insurance",
      htmlAttrs: { lang: "en" },
    });
  },
});
